module.exports = __webpack_public_path__ + "static/media/mv.5027047f.svg";